import Api from './../service/Api';

export default {
  findAllAulasByCpf: cpf => Api.get(`aulas/${cpf}`),
  deleteById: id => Api.delete(`aulas/${id}`),
};
